<template>
<div class="custom-header" ref="custom-header">
  <van-nav-bar :title="titleName" v-if="showNav" placeholder :border="false" @click-left="onClickLeft">
    <template #left>
      <van-icon name="arrow-left" size="18" color="#333" />
    </template>
    
  </van-nav-bar>
  <!--  :style="{ position: showUser ? 'fixed' : 'relative', left: 0, top: 0 }" -->
  <div class="header">
    <div class="search" @click="goSearch">
      <img class="icon" src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/search_icon.png" alt="" />
      <span>搜索您感兴趣的内容</span>
    </div>
    <div class="user-center" v-if="isLogin" @click="toPage('./user/mine')">
      <p>个人</p>
      <p>中心</p>
    </div>
    <div class="user-center" v-else @click="toPage('./login/phone')">
       登录/注册
    </div>
  </div>
  <div class="index-tab-header" id="tab">
    <van-tabs  color="#A40001" v-model="activeName" :ellipsis="false" :before-change="onChange">
      <van-tab :title="item.name" v-for="(item, index) of indexTab" :key="index" :name="item.path"></van-tab>
    </van-tabs>
  </div>
</div>
</template>

<script>
export default {
  props: {
    showUser: {
      type: Boolean,
    },
    showNav: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
    };
  },
  mounted() {
    let r = this.$route;
    // if (r.name == 'index' || r.name == 'train' || r.name == 'lesson' || r.name == 'live' || r.name == 'media' || r.name == 'idea') {
      this.$store.commit("SET_HEADER", r.name);
    // }
    this.$store.commit("SET_HEADER_HEIGHT", this.$refs['custom-header'].offsetHeight);

  },
  computed: {
    isLogin(){
      return localStorage.getItem('token') ? true : false
    },
    activeName: {
      get() {
        return this.$store.state.headerActive;
      },
      set(value) {
        return this.$store.headerActive;
      },
    },
    titleName() {
      return this.$store.state.plat.name;
    },
    plat() {
      return this.$store.state.plat_id;
    },
    indexTab() {
      console.log(this.$store.state.indexTab)
      return this.$store.state.indexTab2
      if (this.$store.state.plat_id == '107' || this.$store.state.plat_id == '121') {
        return this.$store.state.indexTab.filter(e => {
          return e.id == 1 || e.id == 32 || e.id == 4 || e.id == 5 || e.id == 6
        });
      } else if(this.$store.state.plat_id == '120'){
        return this.$store.state.indexTab.filter(e => {
          return e.id == 1 || e.id == 3
        });
      }else {
        return this.$store.state.indexTab.filter(e => {
          return e.id !== 32
        });
      }

    },
    indexData() {
      console.log("this.$store.state.plat", this.$store.state.plat);
      if (
        this.$store.state.plat_id == "119" ||
        this.$store.state.plat_id == "118"
      ) {
        return this.$store.state.plat.indexData;
      } else {
        let arr = this.category.map((e) => {
          return e;
        });
        arr.push({
          category_id: 0,
          category_name: "全部分类",
        });
        return arr;
      }
    },
  },
  methods: {
    toPage(url){
      this.$router.push(url);
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    goSearch() {
      this.$router.push(`./search`);
    },
    onChange(name) {
      this.$router.push(`./${name}`);
      return false;
    },
  },
  watch: {
    $route(newval, oldval) {
      console.log("this.$store.state", newval, oldval, this.$store.state.headerActive);
      if (newval.name == 'index' || newval.name == 'train' || newval.name == 'lesson' || newval.name == 'live' || newval.name == 'media') {
        this.$store.commit("SET_HEADER", newval.name);
      }
      this.$store.commit("SET_HEADER_HEIGHT", this.$refs['custom-header'].offsetHeight);
      
    },
  },
};
</script>

<style scoped>
.index-tab-header {
  /* top: 96px; */
}

.custom-header {
  width: 100%;
  overflow: hidden;
  background: #fff;
  position: relative;
  z-index: 999;
  /* height: 90px; */
  position: fixed;
  left: 0;
  top: 0;
}

.header {
  width: 100vw;
  height: 96px;
  display: flex;
  align-items: center;
  background: #fff;
  z-index: 99;
}

.search {
  flex: 0 1 auto;
  border-radius: 33px;
  width: 690px;
  height: 66px;
  background: #f0f2f8;
  font-size: 28px;
  font-weight: 400;
  color: #9fa2b3;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 30px;
}

.icon {
  width: 31px;
  height: 31px;
  margin-right: 20px;
}

.user-center {
  flex: 0 0 118px;
  width: 118px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #555;
  font-size: 26px;
  line-height: 30px;
}
</style>>
